import { useMarketAnalysisSectionContent } from './useMarketAnalysisSectionContent';
import { parseMarketAnalysisHeroContent } from '../utils/marketAnalysisContent';

export const useMarketAnalysisHeroContent = () =>
  useMarketAnalysisSectionContent(parseMarketAnalysisHeroContent);
